<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> All Students Bill Report</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_ay"
                        :items="ay_list" item-text="ay" item-value="id" label="Select Academic Year" outlined
                        persistent-hint hint="Please Select Academic year" @change="putNull()"/>
                </v-col>
                <v-col cols="12" sm="2" md="2" >
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_standard"
                        :items="standard_list" item-text="standard" item-value="id" label="Please Select Standard" outlined
                         persistent-hint hint="Please Select Standard" @change="getDivisions()"/>
                </v-col>
                 <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="selected_div" :items="division_list"
                        item-text="division_name" item-value="id" label="Please Select Division" persistent-hint
                        hint="Please Select Division" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="category" :items="category_list"
                        item-text="name" item-value="id" label="Please Select Category Type" persistent-hint multiple
                        hint="Please Select Category Type" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-btn class="mt-6 button" @click="getAllStudentsBillReport()" :loading="fetch_loader">Get Report</v-btn>
                </v-col>
            </v-row>

            <v-row justify="center" class="mt-10">
            <v-col cols="12">
                <span v-if="report_data && report_data.length>0">
                     <span>
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>

                        <v-btn rounded class="no-display" color="success" outlined @click="downloadFile" :loading="loader">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>

                <div class="printing_area">
                    <div class="table-wrapper"> 
                        <div class="table-inner">
                            <table class="main-table">
                                    <thead>
                                        <tr>
                                            <th colspan="2">Std : {{ selectedStd }}</th>

                                            <th v-for="(items, category) in groupedHeaders"
                                                :key="category"
                                                :colspan="items.length">
                                                {{ category }}
                                            </th>
                                        </tr>

                                        <tr>
                                            <th>Contents</th>
                                            <th>Total</th>

                                            <template v-for="(items, category) in groupedHeaders">
                                                <th v-for="item in items" :key="item.name">
                                                    {{ item.name }}
                                                </th>
                                            </template>
                                        </tr>

                                        <tr>
                                            <th>Name Of Students</th>
                                            <th>Price</th>

                                            <template v-for="(items, category) in groupedHeaders">
                                                <th v-for="item in items" :key="'price-' + item.name">
                                                    ₹{{ item.base_price }}
                                                </th>
                                            </template>
                                        </tr>
                                    </thead>
                                <tbody>
                                    <tr v-for="student in tableData" :key="student.learner_name">
                                        <td>{{ student.learner_name }}</td>
                                        <td>₹{{ student.total_price }}</td>

                                        <template v-for="(items, category) in groupedHeaders">
                                            <td v-for="item in items" :key="item.name">
                                                <div v-if="student.items[item.name.toLowerCase().trim()]">
                                                    <div>
                                                        ₹{{ student.items[item.name.toLowerCase().trim()].price }}
                                                    </div>
                                                    <v-divider class="my-1"></v-divider>
                                                    <div>
                                                        {{ student.items[item.name.toLowerCase().trim()].qty }}
                                                    </div>
                                                </div>
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                                <br/><br/>
                            </table>
                    
                            <div class="footer-row">
                                <div class="footer-col">Store Keeper</div>
                                <div class="footer-col">Principal</div>
                            </div>
                         </div>
                    </div>
                </div>
                    </span>        
                </span>
            </v-col>
            </v-row> 
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import * as XLSX from "xlsx";
    import "@/assets/css/color.css"; 
    export default {
       
        data() {
            return {
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                fetch_loader: false,
                ay_list : [],
                selected_ay:"",
                selected_section : "",
                selected_div:"",
                selected_standard:"",
                display_ay:"",
                display_standard:"",
                student:"",
                category:[],
                division_list : [],
                standard_list : [],
                report_data : [],
                org_basic_data : [],
                students_list:[],
                category_list:[],
                category_names:[],
                header_items:[],
                tableData: [],
                standard:"",
                learner_name:"",
                rollno:"",
                total_price:"",
                selectedStd:""
            };
        },
        computed: {
            groupedHeaders() {
                let map = {}

                this.header_items.forEach(item => {
                if (!map[item.category_type]) {
                    map[item.category_type] = []
                }
                map[item.category_type].push(item)
                })

                return map
            }
        },
        methods: {
          print() {
                const content = document.querySelector(".printing_area").innerHTML;

                let totalColumns = 2;
                Object.values(this.groupedHeaders).forEach(items => {
                    totalColumns += items.length;
                });

                let zoom = 1;
                let fontSize = 12;

                if (totalColumns <= 6) {
                    zoom = 1;
                    fontSize = 14;
                } else if (totalColumns <= 10) {
                    zoom = 0.85;
                    fontSize = 12;
                } else if (totalColumns <= 15) {
                    zoom = 0.7;
                    fontSize = 11;
                } else {
                    zoom = 0.6;
                    fontSize = 10;
                }

                const win = window.open("", "", "width=1400,height=900");

                win.document.write(`
                    <html>
                    <head>
                        <title>Print</title>
                        <style>
                            @page {
                                size: A4 landscape;
                                margin: 5mm;
                            }

                            body {
                                font-family: Arial;
                                zoom: ${zoom};
                            }

                            table {
                                border-collapse: collapse;
                                width: 100%;
                            }

                            th, td {
                                border: 1px solid #000;
                                padding: 4px;
                                font-size: ${fontSize}px;
                                text-align: center;
                                white-space: nowrap;
                            }

                            th {
                                background: #f5f5f5;
                            }

                            .footer-row {
                                display: flex;
                                justify-content: space-between;
                                margin-top: 30px;
                            }

                            .footer-col {
                                width: 50%;
                                text-align: center;
                                font-weight: bold;
                            }
                        </style>
                    </head>
                    <body>
                        ${content}
                    </body>
                    </html>
                `);

                win.document.close();
                win.focus();
                win.print();
                win.close();
            },
        
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            onload() {
                axios
                    .post("/QuizScheduling/getAllData")
                    .then((res) => {
                        if(res.data.flag =="YES"){
                            this.ay_list = res.data.ay_list;
                            this.semester_list = res.data.semester_list;
                            this.standard_list = res.data.standard_list
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
            },

            getDivisions() {
                const data={
                    ay: this.selected_ay,
                    standard: this.selected_standard
                }
                axios
                    .post("/EduStore/getDivisionsOfAy",data)
                    .then((res) => {
                        if(res.data.flag =="YES"){
                           this.division_list = res.data.division_list;
                           this.category_list = res.data.category_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
            },

            getAllStudentsBillReport() {
                if(!this.selected_ay || !this.selected_standard || !this.selected_div || !this.category){
                    this.showSnackbar("#b71c1c", "Please Select All Fields");
                    return
                }
                this.fetch_loader = true;
                const data = {
                    ay : this.selected_ay,
                    standard : this.selected_standard,
                    div : this.selected_div,
                    category_list: this.category,
                };
                axios
                    .post("/EduStore/getAllStudentsBillReport", data)
                    .then((res) => {
                        if (res.data.msg === "200") {
                            this.report_data = res.data.all_reports;
                            this.org_basic_data = res.data.org_basic_data;
                            this.category_names = res.data.category_names;
                            this.header_items = res.data.header_items;
                            this.selectedStd = res.data.selectedStd;
                            this.prepareTableData();   
                            this.showSnackbar("success", "Data Fetched Successfully");
                        }else if (res.data.flag === "NA"){
                             this.showSnackbar("#b71c1c", res.data.msg);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        this.fetch_loader = false;
                    })
                    .finally(() => { 
                        this.fetch_loader = false; 
                    });
            },
            putNull(){
                this.selected_standard = null;
                this.selected_div = null;
            },
            downloadFile() {
                this.loader = true;

                try {
                    let rows = [];

                    let row1 = ["", "Std : " + this.selectedStd];
                    Object.keys(this.groupedHeaders).forEach(category => {
                        const count = this.groupedHeaders[category].length;
                        row1.push(category);
                        for (let i = 1; i < count; i++) row1.push("");
                    });
                    rows.push(row1);

                    let row2 = ["Contents", "Total"];
                    Object.values(this.groupedHeaders).forEach(items => {
                        items.forEach(item => {
                            row2.push(item.name);
                        });
                    });
                    rows.push(row2);

                    let row3 = ["Name Of Students", "Price"];
                    Object.values(this.groupedHeaders).forEach(items => {
                        items.forEach(item => {
                            row3.push("₹" + item.base_price);
                        });
                    });
                    rows.push(row3);

                    this.tableData.forEach(student => {
                        let row = [
                            student.learner_name,
                            student.total_price
                        ];

                        Object.values(this.groupedHeaders).forEach(items => {
                            items.forEach(item => {
                                const key = item.name.toLowerCase().trim();

                                if (student.items[key]) {
                                    row.push(
                                        `₹${student.items[key].price} (${student.items[key].qty})`
                                    );
                                } else {
                                    row.push("");
                                }
                            });
                        });

                        rows.push(row);
                    });

                    const ws = XLSX.utils.aoa_to_sheet(rows);

                    let merges = [];
                    let colIndex = 2;

                    Object.values(this.groupedHeaders).forEach(items => {
                        if (items.length > 1) {
                            merges.push({
                                s: { r: 0, c: colIndex },
                                e: { r: 0, c: colIndex + items.length - 1 }
                            });
                        }
                        colIndex += items.length;
                    });

                    ws["!merges"] = merges;

                    ws["!cols"] = rows[0].map(() => ({ wch: 18 }));

                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Report");

                    XLSX.writeFile(wb, "Student_Report.xlsx");

                    this.showSnackbar("success", "Excel Downloaded");

                } catch (e) {
                    this.showSnackbar("#b71c1c", "Export failed");
                } finally {
                    this.loader = false;
                }
            },

            prepareTableData() {
                let result = []

                this.report_data.forEach(student => {
                    let row = {
                        learner_name: student.learner_name,
                        total_price: student.total_price,
                        items: {}
                    }

                    student.report_data.forEach(item => {
                    if (item.price != null) {
                        const key = item.item.toLowerCase().trim()  

                        row.items[key] = {
                        price: item.price,
                        qty: item.qty
                        }
                    }
                    })
                    result.push(row)
                })

                this.tableData = result
                console.log("TABLE DATA:", this.tableData)
            }
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style>
.table-wrapper {
    width: 100%;
    overflow-x: auto;  
}

.main-table {
    border-collapse: collapse;
    width: max-content; 
    min-width: 100%;    
}

.main-table th,
.main-table td {
    border: 1px solid #000;
    text-align: center;
    padding: 8px 12px;
    font-size: 14px;
    white-space: nowrap;   
}

.main-table th {
    font-weight: bold;
    background: #f5f5f5;
}
.table-inner {
    width: max-content;  
    min-width: 100%;
}

.footer-row {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}

.footer-col {
    width: 50%;
    text-align: center;
    font-weight: bold;
}
@media print {

    body * {
        visibility: hidden !important;
    }

    .printing_area,
    .printing_area * {
        visibility: visible !important;
    }

    .printing_area {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        border: none;
    }

    table,
    th,
    td {
        border: 1px solid #000 !important;
    }
   
    @page {
        size: A4 portrait;
        margin: 5mm;
    }
}
</style>